import { memo, useEffect, useState } from 'react';
import { Icon, Text } from '../../../components';
import "./BurgerMenu.scss";
import { scrollToElement } from '../../../utils';

type Props = {
  navItems: { label: string, link: string}[],
}

function MemoComponent({ navItems }: Props) {
  const [ isOpen, setIsOpen ] = useState(false);

  const onClickOutside = (event: any) => {
    if (!event.target.closest('.burger-menu')) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', onClickOutside);
    return () => {
      window.removeEventListener('click', onClickOutside);
    };
  }, []);

  return (
    <div className="burger-menu">
      <div className="burger-menu-icon cursor-pointer">
        <Icon className="icon-burger-menu" size={50} onClick={() => setIsOpen(!isOpen)} />
      </div>

      {isOpen && (
        <ul className="burger-menu-list">
          {navItems.map((item: any) => (
            <li key={item.label}>
              <Text
                variant="content2"
                className="as-link cursor-pointer"
                weight={500}
                align="right"
                onClick={() => scrollToElement(item.link)}
              >
                {item.label}
              </Text>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export const BurgerMenu = memo(MemoComponent);